export default __webpack_public_path__ + "static/media/down_arrow_orange.d9cda907.svg";